// extracted by mini-css-extract-plugin
export default {"asyncSP":"styles_asyncSP__ufLgE","primeros":"styles_primeros__yW9jg"};